export default __webpack_public_path__ + "img/sketch.a6af780a.jpg";